import {makeStyles} from "@material-ui/core";

export default makeStyles(theme => ({
  dialogSuccessContent: {
    padding: '30px !important',
  },
  dialogSuccessContainer: {
    fontFamily: 'Roboto-Regular',
    fontSize: 16,
    color: '#202A38'
  },
  questionContainer: {
    position: "relative"
  },
  addBtnContainer: {
    position: "absolute",
    top: -35,
    right: 0
  },
  acceptButton: {
    textTransform: 'none',
    fontFamily: 'Roboto-Bold',
    borderRadius: 8,
    fontSize: 16,
    padding: '11px 22px',
  },
  buttonRoot: {},
  buttonRootDisabled: {
    '& rect': {
      fill: 'rgba(0, 0, 0, 0.1) !important',
    },

    '& path': {
      fill: 'rgba(0, 0, 0, 0.38) !important'
    }

  }
}))